var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getAuthenticatedUserGroupLevel === '1')?_c('div',[_c('BaseHeader',{attrs:{"title":_vm.$t('edit_rental_car').toString()}}),_c('RentalCarForm',{attrs:{"edit-mode":true}})],1):_c('Forbidden')
}
var staticRenderFns = []

export { render, staticRenderFns }